import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const LCCOFIN_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/lccofin/logo.png",
        alt: "Lykins Counseling Clinic Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 46,
  state: "IN",
  departmentIds: [263],
};
